export const RequireWeb3 = () => {
  return (
    <div>
      <div>MetaMask is required to use this application.</div>
      <div>
        If you do not have a MetaMask, you can download it{" "}
        <a
          rel="noopener noreferrer nofollow"
          target="_blank"
          href="https://metamask.io/download"
        >
          here.
        </a>
      </div>
    </div>
  );
};
